export const LOGIN_SUCCESS = 'You are successfully logged in.';
export const LOGIN_ERROR = 'Your username or password is incorrect.';
export const FORGET_PASSWORD_SUCCESS = 'The link has been sent via email.';
export const FORGET_PASSWORD_ERROR = 'The email does not exist.';
export const SOMETHING_WENT_WRONG = 'Something went wrong.';
export const RECORD_ADDED_SUCCESSFULLY = 'Record added successfully.';
export const RECORD_DELETED_SUCCESSFULLY = 'Record deleted successfully.';
export const RECORD_UPDATED_SUCCESSFULLY = 'Record updated successfully.';
export const STATUS_UPDATED_SUCCESSFULLY = 'Status updated successfully.';
export const CANCEL_INVOICE_SUCCESSFULLY = 'Cancel invoice successfully.';
